
import { defineComponent, ref, Ref, onMounted, inject } from "vue";
import CloseSVG from "@/components/CloseSVG.vue";
import Login from "@/components/Modals/User/Login.vue";
import SignUp from "@/components/Modals/User/SignUp.vue";
export default defineComponent({
  name: "LoginModal",
  components: {
    CloseSVG,
    Login,
    SignUp,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const title = ref("");
    const loginRef = ref<HTMLInputElement>();
    const signUpRef = ref<HTMLInputElement>();
    const loginSelected = ref(true);

    onMounted(() => {
      if (loginRef.value) {
        loginRef.value.checked = true;
      }

      //Trigger rerender on mount
      title.value = "Log in to your account";
    });

    const selectLogin = () => {
      loginSelected.value = true;

      if (loginRef.value) {
        loginRef.value.checked = true;
      }
    };

    const selectSignup = () => {
      loginSelected.value = false;

      if (signUpRef.value) {
        signUpRef.value.checked = true;
      }
    };

    const handleChange = (value: string) => {
      if (value === "signUp") {
        loginSelected.value = false;
      } else {
        loginSelected.value = true;
      }
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      title,
      loginRef,
      loginSelected,
      signUpRef,
      handleChange,
      selectLogin,
      selectSignup,
    };
  },
});
